module.exports = __webpack_public_path__ + "static/media/Different World.90c598ef.mp3";